import { Colors, Icon } from '@gripp/shared-ui';
import { FC } from 'react';
import { Pressable, StyleSheet } from 'react-native';

type HeaderResetButtonProps = {
  onReset: () => void | Promise<void>;
};

export const HeaderResetButton: FC<HeaderResetButtonProps> = ({
  onReset,
}) => {
  return (
    <Pressable 
      onPress={onReset}
      style={styles.container}
      accessibilityRole="button"
      accessibilityLabel="Reset Button"
    >
      <Icon
        name="Reset"
        size={24}
        color={Colors.role.textStrong}
      />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 56,
    height: 56,
    minWidth: 56,
    maxHeight: 56,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
});
